import { Mail, Calendar, Users, User, AlignLeft, X } from "lucide-react";
import "../../styles/modal.css";

export default function NewsletterDetailsModal({ tr, onClose }) {
  if (!tr) return null;

  const admin = tr.admin;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <div className="headerIcon">
            <Mail size={24} color="#D6A62A" />
          </div>
          <div>
            <div className="modalName">{tr.title}</div>
            <div className="modalRole">ID Diffusion: #{tr.id}</div>
          </div>
          <button className="modalClose" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modalSection">
          <h4 className="modalSectionTitle">Contenu du Message</h4>
          <div className="contentBox">
            <p className="messageText">{tr.content}</p>
          </div>
        </div>
        <div className="modalSection">
          <h4 className="modalSectionTitle">Informations Générales</h4>
          <div className="modalGrid">
            <Info
              icon={<Calendar size={14} />}
              label="Date d'envoi"
              value={
                tr.created_at
                  ? new Date(tr.created_at).toLocaleString("fr-FR")
                  : "N/A"
              }
            />
            <Info
              icon={<Users size={14} />}
              label="Destinataires"
              value={`${tr.sent_to_count || 0} utilisateurs`}
            />
            <Info
              icon={<User size={14} />}
              label="Expéditeur"
              value={
                admin ? `${admin.firstName} ${admin.lastName}` : "Admin système"
              }
            />
            <Info icon={<Mail size={14} />} label="Type" value="Push & Email" />
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ icon, label, value }) {
  return (
    <div className="infoItem">
      <span className="infoLabel">
        {icon} {label}
      </span>
      <span className="infoValue">{value || "-"}</span>
    </div>
  );
}
